import { IElement } from "../../../interfaces/form-builder/i-element";
import { IAncestorSettings } from "../../../interfaces/form-builder/i-input-options";
import { bindable } from "aurelia-framework";
import { bindingMode } from "aurelia-binding";

export class TabGroup {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public element: IElement;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public ancestorSettings: IAncestorSettings;
}
